import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { OneActionComponent } from './main/dialogs/one-action/one-action.component';
import { PdfViewerComponent } from './main/dialogs/pdf-viewer/pdf-viewer.component';
import { ResumeHiringComponent } from './main/dialogs/resume-hiring/resume-hiring.component';
import { TwoActionsComponent } from './main/dialogs/two-actions/two-actions.component';

import { AppRoutingModule } from './routing/app-routing.module';

import { AppComponent } from './app.component';
import { GlobalModule } from './global/global.module';
import { ViewModelModule } from './view-model/view-model.module';

import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { environment } from '../environments/environment';
import { ErrorInterceptor } from './global/helpers/errors.interceptor';
import { JwtInterceptor } from './global/helpers/jwt.interceptor';
import { CiViewerComponent } from './main/dialogs/ci-viewer/ci-viewer.component';
import { DialogThreeInfoComponent } from './main/dialogs/dialog-three-info/dialog-three-info.component';
import { QuieroAyudaComponent } from './main/dialogs/full-screem/quiero-ayuden/quiero-ayuden.component';
import { SinActividadComponent } from './main/dialogs/full-screem/sin-inicio/sin-actividad.component';
import { DialogErrorComponent } from './main/dialogs/dialog-error/dialog-error.component';
import { ValoresMCCComponent } from './main/dialogs/valores-mcc/valores-mcc.component';
import { PagesModule } from './main/pages/pages.module';
import { DialogRoundedComponent } from './main/dialogs/dialog-rounded/dialog-rounded.component';


@NgModule({
  declarations: [
    AppComponent,
    OneActionComponent,
    DialogErrorComponent,
    DialogRoundedComponent,
    TwoActionsComponent,
    PdfViewerComponent,
    ResumeHiringComponent,
    DialogThreeInfoComponent,
    SinActividadComponent,
    QuieroAyudaComponent,
    CiViewerComponent,
    ValoresMCCComponent
  ],
  entryComponents: [
    OneActionComponent,
    DialogErrorComponent,
    TwoActionsComponent,
    SinActividadComponent,
    QuieroAyudaComponent,
    DialogThreeInfoComponent,
    ValoresMCCComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    HttpClientModule,
    AppRoutingModule,
    NgxExtendedPdfViewerModule,
    GlobalModule,
    ViewModelModule,
    PagesModule,
    LayoutModule

  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: 'googleTagManagerId', useValue: environment.keytaqManager }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
